import { Outlet } from "react-router";

const Zones = () => {
	return <Outlet />;
};

export default Zones;
